import { Input, Space, Collapse, Typography,Col ,Row } from 'antd'
import React from 'react'
import { Pie , Column } from '@ant-design/plots';
import { FontSizeOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const Title =Typography;

const pubData = [
  { type: '2026', value: 6 },
  { type: '2025', value: 25 },
  { type: '2024', value: 8 },
  { type: '2023', value: 6 },
  { type: '2022', value: 4 },
  { type: '2021', value: 3 },
  { type: '2020', value: 1 },
  { type: '2019', value: 1 },
  { type: '2018', value: 4 },
  { type: '2017', value: 6 },
];

const PubPie = () => {
    const config = {
      appendPadding: 10,
      data: pubData,
      angleField: 'value',
      colorField: 'type',
      radius: 0.9,
      label: {
        type: 'outer',
        content: '{name} {percentage}',
      },
      interactions: [
        {
          type: 'pie-legend-active',
        },
        {
          type: 'element-active',
        },
      ],
    };
    return <Pie {...config} />;
  };

  const liStyle = {
    fontFamily: "Arial",
    margin:15

};

const pieChartHeight = '360px'; // Set your desired pie chart height

const Publications = () => {
  const totalPublications = pubData.reduce((sum, d) => sum + d.value, 0);
  return (
    <>

        <Title style={ {  textAlign: 'center', margin:'10px 0' }} ><h4>Aditya L1 Publications</h4></Title>

              <Row align="middle" gutter={16}>
                <Col flex="auto">
                  <div style={{ height: pieChartHeight }}>
                    <PubPie />
                  </div>
                </Col>
                <Col flex="160px" style={{ textAlign: 'center', fontFamily: 'Arial' }}>
                  <div style={{ fontSize: '16px', color: '#555' }}>Total Publications</div>
                  <div style={{ fontSize: '48px', fontWeight: 'bold', lineHeight: 1.2 }}>{totalPublications}</div>
                  <div style={{ fontSize: '14px', color: '#888', marginTop: 4 }}>peer-reviewed papers</div>
                </Col>
              </Row>

        <Collapse accordion defaultActiveKey={['11']} >
        <Panel header="2026" key="11">
            <ol>
            <li style={liStyle}><a href="https://doi.org/10.3847/2041-8213/ae2ac9" target="_blank"> Parashar, S., Chakrabarty, D., Kumar, P. et al., "Evidence for In Situ Particle Energization during the 2024 May Event Based on the ASPEX Instrument on Board Aditya-L1", <i>The Astrophysical Journal Letters</i>, vol. 996, no. 2, 2026. https://doi.org/10.3847/2041-8213/ae2ac9
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s12036-025-10125-0" target="_blank"> Singh, A.K., Srivastava, V.K., Agarwal, S., "Lagrange point orbit prediction using high-fidelity orbit propagator and orbit representation in rotating reference frame", <i>Journal of Astrophysics and Astronomy</i>, vol. 47, no. 3, 2026. https://doi.org/10.1007/s12036-025-10125-0
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s10686-026-10051-1" target="_blank"> Yadav, V.K., Agarwal, P., Narendra, S. et al., "Design and development of a deployable boom for the MAG payload onboard Aditya-L1 spacecraft", <i>Experimental Astronomy</i>, vol. 61, no. 12, 2026. https://doi.org/10.1007/s10686-026-10051-1
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s12036-026-10134-7" target="_blank"> Sebastian, J., Dalal, B., Gupta, A. et al., "One Year of ASPEX-STEPS Operation: Characteristic Features, Observations and Science Potential", <i>Journal of Astrophysics and Astronomy</i>, vol. 47, no. 21, 2026. https://doi.org/10.1007/s12036-026-10134-7
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s12036-026-10147-2" target="_blank"> Kathiravan, C., Muthu Priyal, V., Ramesh, R., "Constraining the onset height of coronal mass ejection driven shocks using near-Sun observations in visible and radio wavelengths", <i>Journal of Astrophysics and Astronomy</i>, vol. 47, no. 29, 2026. https://doi.org/10.1007/s12036-026-10147-2
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1016/j.newast.2026.102554" target="_blank"> Shirke, A.V., Charde, S.S., Singh, B.P., "Analysis of solar flare and sunspots on 4th Jan 2025 and their effects on space weather", <i>New Astronomy</i>, vol. 126, 2026. https://doi.org/10.1016/j.newast.2026.102554
                </a>
            </li>
            </ol>
        </Panel>
        <Panel header="2025" key="10">
            <ol>
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02468-2" target="_blank"> Sarkar, J., Nived, V.N., Roy, S. et al, "Test and Calibration of the Solar Ultraviolet Imaging Telescope (SUIT) on Board Aditya-L1", <i>Sol Phys</i>, vol. 300, no. 60, 2025. https://doi.org/10.1007/s11207-025-02468-2
                </a>
            </li>
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02423-1" target="_blank"> Tripathi, D., Ramaprakash, A.N., Padinhatteeri, S. et al., "The Solar Ultraviolet Imaging Telescope on Board Aditya-L1", <i>Sol Phys</i>, vol. 300, no. 30, 2025. https://doi.org/10.1007/s11207-025-02423-1

                </a>
            </li>
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02440-0" target="_blank"> Yadav, V.K., Vijaya, Y., Krishnam Prasad, B. et al. "The Fluxgate Magnetometer (MAG) on Board Aditya-L1 Spacecraft", <i>Sol Phys</i>, vol. 300, no. 30, 2025. https://doi.org/10.1007/s11207-025-02440-0

                </a>
            </li> 
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02443-x" target="_blank"> Kumar, P., Bapat, B., Shah, M.S. et al., "Aditya Solar Wind Particle Experiment (ASPEX) on Board Aditya—L1: The Solar Wind Ion Spectrometer (SWIS)", <i>Sol Phys</i>, vol. 300, no. 37, 2025. https://doi.org/10.1007/s11207-025-02443-x

                </a>
            </li>
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02441-z" target="_blank"> Goyal, S.K., Tiwari, N.K., Patel, A.R. et al., "Aditya Solar Wind Particle Experiment on Board Aditya–L1: The Supra-Thermal and Energetic Particle Spectrometer", <i>Sol Phys</i>, vol. 300, no. 35, 2025. https://doi.org/10.1007/s11207-025-02441-z

                </a>
            </li>

            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-024-02414-8" target="_blank"> Thampi, R.S., Abhishek, J.K., Sasidharan, D. et al., "Plasma-Analyzer Package for Aditya (PAPA) on Board the Indian Aditya-L1 Mission", <i>Sol Phys</i>, vol. 300, no. 9, 2025. https://doi.org/10.1007/s11207-024-02414-8

                </a>
            </li>
            <li style={liStyle} ><a href="https://iopscience.iop.org/article/10.3847/2041-8213/adc387" target="_blank"> Roy, S., Tripathi, D., Upendran, V., Padinhatteeri, S., Ramaprakash, A., V. N., N., Sankarasubramanian, K., Solanki, S., Sarkar, J., Gopalakrishnan, R., Deogaonkar, R., Nandy, D., & Banerjee, D., "X-class Flare on 2023 December 31 Observed by the Solar Ultraviolet Imaging Telescope on Board Aditya-L1", <i>The Astrophysical Journal Letters</i>, vol. 983, no. 1, 2025. https://dx.doi.org/10.3847/2041-8213/adc387

                </a>
            </li>
            <li style={liStyle} ><a href="https://iopscience.iop.org/article/10.3847/1538-4357/adbe73" target="_blank">Muthu Priyal, V., Ramesh, R., Singh, J., & Sasikumar Raja, K., "Observations of Temporal Variations in the 5303 Å Emission Line During a Coronal Mass Ejection Without Any Associated Solar Flare," in <i>The Astrophysical Journal</i>, vol. 983, no. 2, pp. 171, 2025. https://dx.doi.org/10.3847/1538-4357/adbe73
                </a>
            </li>
            <li style={liStyle} ><a href="https://iopscience.iop.org/article/10.3847/2041-8213/adb0be" target="_blank">Roy, S., Tripathi, D., Padinhatteeri, S., Ramaprakash, A., Sarwade, A., V. N., N., Sarkar, J., Gopalakrishnan, R., Deogaonkar, R., Sankarasubramanian, K., Solanki, S., Nandy, D., & Banerjee, D., "Near- and Mid-ultraviolet Observations of X-6.3 Flare on 2024 February 22 Recorded by the Solar Ultraviolet Imaging Telescope on board Aditya-L1," in <i>The Astrophysical Journal Letters</i>, vol. 981, no. 1, pp. L19, 2025. https://dx.doi.org/10.3847/2041-8213/adb0be
                </a>
            </li>
            <li style={liStyle} ><a href="https://link.springer.com/article/10.1007/s11207-025-02477-1" target="_blank"> Singh, J., Ramesh, R., Prasad, B.R. et al., "Visible Emission Line Coronagraph (VELC) on Board Aditya-L1", <i>Sol Phys</i>, vol. 300, no. 66, 2025. https://doi.org/10.1007/s11207-025-02477-1
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s10686-024-09973-5" target="_blank"> Sarkar, J., Deogaonkar, R., Kesharwani, R. et al., "Science filter characterization of the Solar Ultraviolet Imaging Telescope (SUIT) on board Aditya-L1", <i>Experimental Astronomy</i>, vol. 59, no. 1, 2025. https://doi.org/10.1007/s10686-024-09973-5
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1117/1.JATIS.11.1.014005" target="_blank"> Sarkar, J., Roy, S., Ramaprakash, A.N. et al., "Photometric calibration and spectral validation of the Solar Ultraviolet Imaging Telescope onboard Aditya-L1", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 11, no. 1, 2025. https://doi.org/10.1117/1.JATIS.11.1.014005
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s11207-025-02494-0" target="_blank"> Sankarasubramanian, K., Bug, M., Sarwade, A. et al., "Solar Low Energy X-ray Spectrometer (SoLEXS) on Board Aditya-L1 Mission", <i>Sol Phys</i>, vol. 300, no. 87, 2025. https://doi.org/10.1007/s11207-025-02494-0
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s11207-025-02504-1" target="_blank"> Seth, P., Upendran, V., Anand, M. et al., "SPACE-SUIT: an Artificial Intelligence Based Chromospheric Feature Extractor and Classifier for SUIT", <i>Sol Phys</i>, vol. 300, no. 89, 2025. https://doi.org/10.1007/s11207-025-02504-1
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1117/1.JATIS.11.3.034004" target="_blank"> Sarkar, J., Ghosh, A., Padinhatteeri, S. et al., "Design, fabrication, and characterization of the thermal filter assembly on the Solar Ultraviolet Imaging Telescope onboard Aditya-L1", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 11, no. 3, 2025. https://doi.org/10.1117/1.JATIS.11.3.034004
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s11207-025-02533-w" target="_blank"> Parate, N.P., Shaji, N., Srikanth, M. et al., "Aditya-L1 - An Observatory Class Mission: Spacecraft, Mission, and Operations", <i>Sol Phys</i>, vol. 300, no. 128, 2025. https://doi.org/10.1007/s11207-025-02533-w
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.3847/2041-8213/adfe60" target="_blank"> Biswas, S., Bhaskar, A., Raghav, A. et al., "Pinching of ICME Flux Rope: Unprecedented Multipoint Observations of Internal Magnetic Reconnection during Gannon's Superstorm", <i>The Astrophysical Journal Letters</i>, vol. 991, no. 1, 2025. https://doi.org/10.3847/2041-8213/adfe60
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.3847/1538-4357/ae00b6" target="_blank"> Yadav, V.K., Choudhary, R.K., Goutham, M.M., "Observations of the Fluctuations in the Interplanetary Magnetic Field around L1 Point during the Solar Transient Events of 2024 with MAG Payload on board Aditya-L1 Spacecraft", <i>The Astrophysical Journal</i>, vol. 991, no. 2, 2025. https://doi.org/10.3847/1538-4357/ae00b6
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1117/1.JATIS.11.4.045005" target="_blank"> Sarwade, A.R., Kushwaha, A., Ramadevi, M.C. et al., "Solar Low Energy X-ray Spectrometer on board Aditya-L1: ground calibration and in-flight performance", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 11, no. 4, 2025. https://doi.org/10.1117/1.JATIS.11.4.045005
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s11207-025-02543-8" target="_blank"> Nandi, A., Sudhakar, M., Tadepalli, S.P. et al., "HEL1OS – Hard X-ray Spectrometer on Board Aditya-L1", <i>Sol Phys</i>, vol. 300, no. 140, 2025. https://doi.org/10.1007/s11207-025-02543-8
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1063/5.0273204" target="_blank"> Mahajan, M., Yadav, V.K., Vijaya, Y. et al., "The design and realization of electronics package for the flux gate magnetometer (MAG) payload on board Aditya-L1 spacecraft", <i>Review of Scientific Instruments</i>, vol. 96, no. 11, 2025. https://doi.org/10.1063/5.0273204
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s11207-025-02581-2" target="_blank"> Ramesh, R., Muthu Priyal, V., Singh, J., Sasikumar Raja, K., "Spectroscopic Observations of Temporal Changes in the 5303 Å Solar Coronal Emission Line During a Flare", <i>Sol Phys</i>, vol. 300, no. 165, 2025. https://doi.org/10.1007/s11207-025-02581-2
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.3847/1538-4357/ae1a47" target="_blank"> Muthu Priyal, V., Ramesh, R., Singh, J., Sasikumar Raja, K., Gopalswamy, N., "Near-Sun Characteristics of a CME Inferred from Observations in the 5303 Å Coronal Emission Line", <i>The Astrophysical Journal</i>, vol. 994, no. 2, 2025. https://doi.org/10.3847/1538-4357/ae1a47
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.3847/1538-4357/ae1974" target="_blank"> Thampi, S.V., Bhaskar, A., Venugopal, I., Biswas, S., Yadav, V.K., "Extreme Geoeffectiveness by the Turbulent Sheath of the ICME of the 2024 October Space Weather Event", <i>The Astrophysical Journal</i>, vol. 995, no. 2, 2025. https://doi.org/10.3847/1538-4357/ae1974
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.3847/1538-4357/ae1a46" target="_blank"> Gupta, A., Chakrabarty, D., Vadawale, S. et al., "Multidirectional Investigations on Quiet Time Suprathermal Ions Measured by ASPEXSTEPS on Board Aditya L1", <i>The Astrophysical Journal</i>, vol. 995, no. 1, 2025. https://doi.org/10.3847/1538-4357/ae1a46
                </a>
            </li>

            </ol>

        </Panel>


        <Panel header="2024" key="9">
            <ol>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2024ExA....57....7M/abstract" target="_blank"> Mishra, S., "Calibration of VELC detectors on-board Aditya-L1 mission", <i>Experimental Astronomy</i>, vol. 57, no. 2, Springer, 2024. doi:10.1007/s10686-024-09922-2.

                </a>
            </li> 
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2024SoPh..299...32V/abstract" target="_blank"> Varma, M., "Correction to: The Solar Ultra-Violet Imaging Telescope (SUIT) Onboard Intelligence for Flare Observations", <i>Solar Physics</i>, vol. 299, no. 3, 2024. doi:10.1007/s11207-024-02277-z.

                </a>
            </li> 
            <li style={liStyle} ><a href="https://iopscience.iop.org/article/10.3847/2041-8213/ad8c45" target="_blank"> Ramesh, R., et al., "New Results on the Onset of a Coronal Mass Ejection from 5303 Å Emission Line Observations with VELC/ADITYA-L1", <i>The Astrophysical Journal Letters</i>, vol. 976, no. 1, pp. L6, 2024, doi:10.3847/2041-8213/ad8c45.

                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s10686-024-09954-8" target="_blank"> Narra, V. S., et al., "Calibration of spectropolarimetry channel of visible emission line coronagraph onboard Aditya-L1", <i>Experimental Astronomy</i>, vol. 58, no. 2, 2024. https://doi.org/10.1007/s10686-024-09954-8
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1016/j.asr.2024.03.058" target="_blank"> Priyal, M., et al., "Data processing of visible emission line coronagraph onboard ADITYA-L1", <i>Advances in Space Research</i>, vol. 74, no. 1, pp. 547–560, 2024. https://doi.org/10.1016/j.asr.2024.03.058
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1117/1.JATIS.10.2.026004" target="_blank"> Kumar, A., et al., "Detector electronics for visible emission line coronagraph payload of Aditya-L1", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 10, no. 2, 2024. https://doi.org/10.1117/1.JATIS.10.2.026004
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.56042/ijpap.v62i4.7792" target="_blank"> Sirisha, J., et al., "On-Orbit Response Analysis of Silicon Photodetectors in 4-Pi Sun Sensor of Aditya-L1 Mission", <i>Indian Journal of Pure &amp; Applied Physics</i>, vol. 62, no. 4, pp. 267–273, 2024. https://doi.org/10.56042/ijpap.v62i4.7792
                </a>
            </li>
            <li style={liStyle}><a href="https://doi.org/10.1007/s12596-023-01244-4" target="_blank"> Narra, V. S., et al., "Performance evaluation of Littrow lens assembly for Visible Emission Line Coronagraph (VELC) on board Aditya-L1 mission", <i>Journal of Optics</i>, vol. 53, no. 2, pp. 857–862, 2024. https://doi.org/10.1007/s12596-023-01244-4
                </a>
            </li>

            </ol>

        </Panel>

        <Panel header="2023" key="8">
          
            <ol>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2023JATIS...9d4001B/abstract" target="_blank"> Budihal, R. P., "Ground calibration of visible emission line coronagraph on board Aditya-L1 mission", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 9, 2023. doi:10.1117/1.JATIS.9.4.044001.

                </a>
            </li>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2023AcAeJ...1c..70S/abstract" target="_blank"> Sowmya, G., "Technical Overview and Prospect of India's First Solar Mission - Aditya L1 Spacecraft", <i>Acceleron Aerospace Journal</i>, vol. 1, no. 3, pp. 3.70, 2023. doi:10.61359/11.2106-2315.

                </a>
            </li>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2023JAI....1250011N/abstract" target="_blank"> Narra, V. S., "Calibration of Spectropolarimetry Package for Visible Emission Line Coronagraph (VELC) on Board Aditya-L1 Mission", <i>Journal of Astronomical Instrumentation</i>, vol. 12, no. 4, 2023. doi:10.1142/S2251171723500113.

                </a>
            </li>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2023SoPh..298...16V/abstract" target="_blank">  Varma, M., "The Solar Ultra-Violet Imaging Telescope (SUIT) Onboard Intelligence for Flare Observations", <i>Solar Physics</i>, vol. 298, no. 2, 2023. doi:10.1007/s11207-023-02108-7.
                </a>
                
            </li>
            <li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2023RASTI...2..256V/abstract" target="_blank">  Varma, S. V. M., "The Solar Ultraviolet Imaging Telescope: detector characterization and readout electronics testing", <i>RAS Techniques and Instruments</i>, vol. 2, no. 1, pp. 256–263, 2023. doi:10.1093/rasti/rzad013.
                </a>

            </li>
            <li style={liStyle}><a href="https://doi.org/10.18520/cs/v125/i12/1323-1327" target="_blank"> Saha, B. P., et al., "Silicon carbide-based functional components in the Visible Emission Line Coronagraph on-board the ADITYA-L1 mission", <i>Current Science</i>, vol. 125, no. 12, pp. 1323–1327, 2023. https://doi.org/10.18520/cs/v125/i12/1323-1327
                </a>
            </li>
            </ol>

      </Panel>
      <Panel header="2022" key="7">
        
            <ol>
<li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2022JATIS...8d4004N/abstract" target="_blank">
	 Narra, V. S., "Optical metrology on primary mirror of visible emission line coronagraph on board Aditya-L1 mission", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 8, 2022. doi:10.1117/1.JATIS.8.4.044004.
</a>
</li>

<li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2022AdSpR..69.2601S/abstract" target="_blank">
	 Singh, J., "Data pipeline architecture and development for VELC onboard Space Solar Mission AdityaL1", <i>Advances in Space Research</i>, vol. 69, no. 6, pp. 2601–2610, 2022. doi:10.1016/j.asr.2021.12.044.
</a>
</li>


<li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2022AdSpR..69..814S/abstract" target="_blank">
	 Sasikumar Raja, K., Venkata, S., Singh, J., and Raghavendra Prasad, B., "Solar coronal magnetic fields and sensitivity requirements for spectropolarimetry channel of VELC onboard Aditya-L1", <i>Advances in Space Research</i>, vol. 69, no. 1, pp. 814–822, 2022. doi:10.1016/j.asr.2021.10.053.
</a>
</li>

<li style={liStyle} ><a href="https://ui.adsabs.harvard.edu/abs/2022ExA....53...71V/abstract" target="_blank">
	 Venkata, S., Prasad B, R., and Singh, J., "Spectropolarimetry package for visible emission line coronagraph (VELC) on board Aditya-L1 mission", <i>Experimental Astronomy</i>, vol. 53, no. 1, pp. 71–82, 2022. doi:10.1007/s10686-021-09816-7.
</a>
</li>
</ol>
        
      </Panel>
      <Panel header="2021" key="6">
      <ol>
          
      <li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2021ApOpt..60.8145N/abstract" target="_blank" >
 Nagaraju, K., "Spectropolarimeter on board the Aditya-L1: polarization modulation and demodulation", <i>Applied Optics</i>, vol. 60, no. 26, p. 8145, 2021. doi:10.1364/AO.434219.
</a>
</li>

<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2021OptEn..60g4103V/abstract" target="_blank" >
 Venkata, S. and Budihal, R. P., "Light scattering due to particulate contamination over the primary mirror of Visible Emission Line Coronagraph on board Aditya-L1 mission", <i>Optical Engineering</i>, vol. 60, 2021. doi:10.1117/1.OE.60.7.074103.

</a>
</li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2021FrASS...8...88P/abstract" target="_blank" >
 Patel, R., "Characterizing Spectral Channels of Visible Emission Line Coronagraph of Aditya-L1", <i>Frontiers in Astronomy and Space Sciences</i>, vol. 8, 2021. doi:10.3389/fspas.2021.660992.

</a>
</li>
      </ol>
      </Panel>


      <Panel header="2020" key="5">
        <ol>
      <li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2020ExA....50..265N/abstract " target="_blank" >
 Narra, V. S., "Scatter due to Ultraviolet (UV) photopolymerization of molecular contamination on optical surfaces", <i>Experimental Astronomy</i>, vol. 50, no. 2–3, pp. 265–287, 2020. doi:10.1007/s10686-020-09675-8.
</a>
</li>
</ol>
      </Panel>
      <Panel header="2019" key="4">
      <ol>
      <li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2019AdSpR..64.1455S/abstract" target="_blank" >
       Singh, J., Prasad, B. R., Venkata, S., and Kumar, A., "Exploring the outer emission corona spectroscopically by using Visible Emission Line Coronagraph (VELC) on board ADITYA-L1 mission", <i>Advances in Space Research</i>, vol. 64, no. 7, pp. 1455–1464, 2019. doi:10.1016/j.asr.2019.07.007.
      </a> 
      </li>
      </ol>
      </Panel>
      <Panel header="2018" key="3">
        <ol>
        <li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2018P%26SS..163...42G/abstract" target="_blank" >
 Goyal, S. K., "Aditya Solarwind Particle EXperiment (ASPEX) onboard the Aditya-L1 mission", <i>Planetary and Space Science</i>, vol. 163, pp. 42–55, 2018. doi:10.1016/j.pss.2018.04.008.
</a> </li>

<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2018SoPh..293..103P/abstract" target="_blank" >
 Patel, R., Amareswari, K., Pant, V., Banerjee, D., Sankarasubramanian, K., and Kumar, A., "Onboard Automated CME Detection Algorithm for the Visible Emission Line Coronagraph on ADITYA-L1", <i>Solar Physics</i>, vol. 293, no. 7, 2018. doi:10.1007/s11207-018-1323-4.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2018ExA....45..219R/abstract" target="_blank" >
 Raj Kumar, N., Raghavendra Prasad, B., Singh, J., and Venkata, S., "Optical design of visible emission line coronagraph on Indian space solar mission Aditya-L1", <i>Experimental Astronomy</i>, vol. 45, no. 2, pp. 219–229, 2018. doi:10.1007/s10686-017-9569-7.

</a> </li>

<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2018AdSpR..61..749Y/abstract" target="_blank" >
 Yadav, V. K., Srivastava, N., Ghosh, S. S., Srikar, P. T., and Subhalakshmi, K., "Science objectives of the magnetic field experiment onboard Aditya-L1 spacecraft", <i>Advances in Space Research</i>, vol. 61, no. 2, pp. 749–758, 2018. doi:10.1016/j.asr.2017.11.008.
</a> </li>
        </ol>
      </Panel>
      <Panel header="2017" key="2">
      <ol>
      <li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017CSci..113..625S/abstract " target="_blank" >
 Sankarasubramanian, K., "X-ray spectrometers on-board Aditya-L1 for solar flare studies", <i>Current Science</i>, vol. 113, no. 4, p. 625, 2017. doi:10.18520/cs/v113/i04/625-627.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017CSci..113..613R/abstract " target="_blank" >
 Raghavendra Prasad, B., "Visible Emission Line Coronagraph on Aditya-L1", <i>Current Science</i>, vol. 113, no. 4, p. 613, 2017. doi:10.18520/cs/v113/i04/613-615.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017CSci..113..610S/abstract " target="_blank" >
 Seetha, S. and Megala, S., "Aditya-L1 mission", <i>Current Science</i>, vol. 113, no. 4, p. 610, 2017. doi:10.18520/cs/v113/i04/610-612.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017CSci..113..620J/abstract" target="_blank" >
 Janardhan, P., "Probing the heliosphere using in situ payloads on-board Aditya-L1", <i>Current Science</i>, vol. 113, no. 4, p. 620, 2017. doi:10.18520/cs/v113/i04/620-624.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017JATIS...3a4002V/abstract " target="_blank" >
 Venkata, S. N., Prasad, B. R., Nalla, R. K., and Singh, J., "Scatter studies for visible emission line coronagraph on board ADITYA-L1 mission", <i>Journal of Astronomical Telescopes, Instruments, and Systems</i>, vol. 3, 2017. doi:10.1117/1.JATIS.3.1.014002.
</a> </li>
<li style={liStyle}><a href="https://ui.adsabs.harvard.edu/abs/2017CSci..113..616T/abstract" target="_blank" >
 Tripathi, D., Ramaprakash, A. N., Khan, A., Ghosh, A., Chatterjee, S., Banerjee, D., Chordia, P., Gandorfer, A., Krivova, N., Nandy, D., Rajarshi, C., and Solanki, S. K., "The Solar Ultraviolet Imaging Telescope on-board Aditya-L1", <i>Current Science</i>, vol. 113, no. 4, pp. 616–619, 2017. doi:10.18520/cs/v113/i04/616-619.
</a> </li>
       </ol>
      </Panel>

    </Collapse>
    
    </>
  )
}

export default Publications
